export const FETCHING_REPORT = '@@lms/FETCHING_REPORT'
export const FETCHING_REPORT_ERROR = '@@lms/FETCHING_REPORT_ERROR'
export const FETCHING_REPORT_SUCCESS = '@@lms/FETCHING_REPORT_SUCCESS'
export const DELETE_REPORTS_SUCCESS = '@@lms/DELETE_REPORTS_SUCCESS'

export default {
  FETCHING_REPORT,
  FETCHING_REPORT_SUCCESS,
  FETCHING_REPORT_ERROR,
  DELETE_REPORTS_SUCCESS,
}



// WEBPACK FOOTER //
// ./src/redux/reports/types.js